/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 3px 23px;
  width: 100%;

  label {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #5e5e5e;
  }
  .Mui-checked {
    color: #3c71dd !important;
  }
  .MuiSvgIcon-fontSizeSmall {
    font-size: 1rem;
  }
`;
